export default __webpack_public_path__ + "static/media/Locked_Error.a1451af6.svg";